import { format, parse, subDays, subMonths, subWeeks, subYears } from 'date-fns';
import moment from 'moment';
import { getCurrentLanguage } from '@/util/language-util';
import { HistoryChat } from '@/shared/model/ask-goover.model';

export function isToday(date) {
  if (!date) {
    return;
  }
  const inputDate = new Date(date);
  const today = new Date();
  return inputDate.setHours(0, 0, 0, 0) == today.setHours(0, 0, 0, 0);
}

export function convertDateToYYYYMMDD(dateString) {
  try {
    return format(new Date(dateString), 'yyyy-MM-dd');
  } catch (e) {
    return dateString;
  }
}

export function convertTimeStampToMMMMDYYYY(timestamp) {
  try {
    return moment(timestamp, 'YYYYMMDDHHmmss').format('MMMM D, YYYY');
  } catch (e) {
    return timestamp;
  }
}

export function countDaysFromFuture(futureDate) {
  const today = new Date();
  const targetDate = new Date(futureDate);

  // Calculate the difference in milliseconds
  // @ts-ignore
  const differenceInTime = targetDate - today;

  // Convert milliseconds to days (1 day = 86,400,000 ms)
  return Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));
}

export function isInNextSevenDays(dateString) {
  const inputDate = new Date(dateString);
  const today = new Date();

  // Get tomorrow's date (to exclude today)
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  // Get the date exactly 7 days from today
  const sevenDaysLater = new Date();
  sevenDaysLater.setDate(today.getDate() + 7);

  // Check if the input date falls within this range
  return inputDate >= tomorrow && inputDate <= sevenDaysLater;
}

export function convertToYYYY_MM_DD(dateStr: string): string | null {
  try {
    const dateObj: Date = parse(dateStr, 'yyyyMMddHHmmss', new Date());
    return format(dateObj, 'yyyy-MM-dd');
  } catch (error) {
    return dateStr;
  }
}

export function formatDate(date) {
  // console.log('date: ', date);

  const koreanRegex = /[\uAC00-\uD7AF]/;
  if (date && typeof date === 'string') {
    if (koreanRegex.test(date)) {
      return date;
    }
  }

  if (date && typeof date === 'string' && (date.includes('ago') || date.includes('recently'))) {
    try {
      // console.log('case0');
      return formatDateAgo(date);
    } catch (e) {
      return date;
      // return convertAgoDate(date);
    }
  }

  let tempDateParser: any;

  if (date && typeof date === 'string' && date.includes(',')) {
    try {
      // console.log('case1');
      tempDateParser = moment(date, 'MMM D, YYYY').local();

      if (tempDateParser.isValid() && tempDateParser.year() > 2000) {
        return tempDateParser.format('MMMM D, YYYY');
      }
    } catch (e) {
      return date;
    }
  }

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  try {
    // console.log('case2');
    const year: any = date.getUTCFullYear();
    const month: any = date.getUTCMonth();
    const day: any = date.getUTCDate();

    if (isNaN(year) || isNaN(month) || isNaN(day) || year < 2000) {
      throw new Error('');
    }

    return `${monthNames[month]} ${day}, ${year}`;
  } catch (e) {
    try {
      // console.log('case3');
      if (date && typeof date === 'string') {
        if (date.charAt(date.length - 1) === '.') {
          date = date.slice(0, -1).replace('. ', '-').replace('.', '-');
          const [year, month, day] = date.split('-').map(Number);
          date = new Date(Date.UTC(year, month - 1, day)).toISOString();
        }
      }

      const tempDate = new Date(date);

      const year: any = tempDate.getUTCFullYear();
      const month: any = tempDate.getUTCMonth();
      const day: any = tempDate.getUTCDate();

      if (isNaN(year) || isNaN(month) || isNaN(day) || year < 2000) {
        throw new Error('');
      }

      return `${monthNames[month]} ${day}, ${year}`;
    } catch (e0) {
      try {
        // console.log('case4');
        tempDateParser = moment(date, 'YYYYMMDDHHmmss').local();

        if (tempDateParser.isValid() && tempDateParser.year() > 2000) {
          // console.log(tempDateParser.format('MMMM D, YYYY'));
          return tempDateParser.format('MMMM D, YYYY');
        } else {
          throw new Error('');
        }
      } catch (e1) {
        try {
          // console.log('case5');
          tempDateParser = moment(date).local();

          if (tempDateParser.isValid() && tempDateParser.year() > 2000) {
            return tempDateParser.format('MMMM D, YYYY');
          } else {
            throw new Error('');
          }
        } catch (e2) {
          try {
            // console.log('case6');
            tempDateParser = moment(date, 'ddd MMM DD HH:mm:ss UTC YYYY').local();

            if (tempDateParser.isValid() && tempDateParser.year() > 2000) {
              return tempDateParser.format('MMMM D, YYYY');
            } else {
              throw new Error('');
            }
          } catch (e3) {
            try {
              // console.log('case7');
              const result = formatDateAgo(moment(date));

              if (!result || result === 'Invalid date') {
                throw new Error('');
              } else {
                return result;
              }
            } catch (e4) {
              try {
                // console.log('case8');

                const result = formatDateAgo(date);
                if (!result || result === 'Invalid date') {
                  throw new Error('');
                } else {
                  return result;
                }
              } catch (e5) {
                // console.log('case9');
                return date;
              }
            }
          }
        }
      }
    }
  }
}

export function formatFromYYYYMMDDToMonthDate(dateStr: string) {
  try {
    const dateObj = new Date(Number(dateStr.slice(0, 4)), Number(dateStr.slice(4, 6)) - 1, Number(dateStr.slice(6, 8)));
    return format(dateObj, 'MMMM dd (eee)');
  } catch (error) {
    return dateStr;
  }
}

export function convertDateToCustomFormat(dateString, newFormat) {
  try {
    return format(new Date(dateString), newFormat);
  } catch (e) {
    return dateString;
  }
}

export function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function convertDate(date: string, isUtc = false): string {
  if (isUtc) return formatDateAgo(moment.utc(date, 'YYYYMMDDHHmmss'));
  return formatDateAgo(moment(date, 'YYYYMMDDHHmmss'));
}

export function formatDateAgo(dateMoment: moment.Moment | any) {
  const lang = getCurrentLanguage();
  const now = moment();
  const diffInDays = now.diff(dateMoment, 'days');
  const diffInHours = now.diff(dateMoment, 'hours');
  const diffInMinutes = now.diff(dateMoment, 'minutes');

  if (lang === 'ko') {
    if (diffInDays === 0) {
      return diffInHours === 0 ? `${diffInMinutes}분 전` : `${diffInHours}시간 전`;
    }
    return diffInDays < 7 ? `${diffInDays}일 전` : dateMoment.format('YYYY년 M월 D일');
  }

  if (diffInDays < 6) {
    return dateMoment.fromNow();
  }

  const fullMonth = dateMoment.format('MMMM');
  const abbrMonth = dateMoment.format('MMM');
  const monthToShow = ['May', 'June', 'July'].includes(fullMonth) ? fullMonth : abbrMonth;

  return `${monthToShow} ${dateMoment.format('D, YYYY')}`;
}

// export function dateConvert(publishAt) {
//   const dateUtc = moment.utc(publishAt, 'YYYYMMDDHHmmss');
//   const hoursAgo = moment().diff(dateUtc, 'hours');
//   return hoursAgo > 0 ? formatDateAgo(moment.utc(publishAt, 'YYYYMMDDHHmmss')) : formatDateAgo(moment(publishAt, 'YYYYMMDDHHmmss'));
// }

export function dateFilterTextToRange(dateText: string): [string, string] {
  if (!dateText) return null;
  const now = new Date();
  let from: Date;

  switch (dateText) {
    case 'ALL':
      return [null, null];
    case 'ONE_DAY':
      from = subDays(now, 1);
      return [format(from, 'yyyy-MM-dd'), format(now, 'yyyy-MM-dd')];
    case 'ONE_WEEK':
      from = subWeeks(now, 1);
      return [format(from, 'yyyy-MM-dd'), format(now, 'yyyy-MM-dd')];
    case 'ONE_MONTH':
      from = subMonths(now, 1);
      return [format(from, 'yyyy-MM-dd'), format(now, 'yyyy-MM-dd')];
    case 'THREE_MOTHNS':
      from = subMonths(now, 3);
      return [format(from, 'yyyy-MM-dd'), format(now, 'yyyy-MM-dd')];
    case 'SIX_MOTHNS':
      from = subMonths(now, 6);
      return [format(from, 'yyyy-MM-dd'), format(now, 'yyyy-MM-dd')];
    case 'ONE_YEAR':
      from = subYears(now, 1);
      return [format(from, 'yyyy-MM-dd'), format(now, 'yyyy-MM-dd')];
    default:
      return null;
  }
}

/**
 * Group data by date
 * @param {array} data The array contains object: HistoryChat
 * @return {object} Object with key is data and value groups by date
 */
export function groupByDate(data: HistoryChat[]) {
  if (!data || data.length === 0) return {};
  return data.reduce((grouped, item) => {
    // Extract the date part (YYYY-MM-DD) from the historyDate
    const date = item?.historyDate?.split('T')[0] || '';

    if (!grouped[date]) {
      grouped[date] = [];
    }

    // Add the original item to the grouped object
    grouped[date].push(item);

    return grouped;
  }, {});
}

export function parseDate(dateString: string): number {
  const year = parseInt(dateString.slice(0, 4), 10);
  const month = parseInt(dateString.slice(4, 6), 10) - 1; // Months are 0-based
  const day = parseInt(dateString.slice(6, 8), 10);
  const hour = parseInt(dateString.slice(8, 10), 10);
  const minute = parseInt(dateString.slice(10, 12), 10);
  const second = parseInt(dateString.slice(12, 14), 10);
  return new Date(year, month, day, hour, minute, second).getTime();
}

export function isDateInRange(itemDate, startDate, endDate) {
  return itemDate >= startDate && itemDate <= endDate;
}

export function convertToUtcISOString(dateString) {
  const date = new Date(dateString);
  return date.toISOString();
}

// export function convertAgoDate(dateInput: string): string {
//   // console.log('Input: ', dateInput);
//
//   try {
//     const monthNames = [
//       'January',
//       'February',
//       'March',
//       'April',
//       'May',
//       'June',
//       'July',
//       'August',
//       'September',
//       'October',
//       'November',
//       'December',
//     ];
//
//     let tempDate = new Date();
//
//     // if (dateInput.includes('hour')) {
//     //   const hourDiff: number = Number(dateInput.replace(/[^0-9]/g, ''));
//     //   tempDate.setUTCHours(tempDate.getUTCHours() - hourDiff);
//     // }
//
//     if (dateInput.includes('day')) {
//       const dayDiff: number = Number(dateInput.replace(/[^0-9]/g, ''));
//
//       if (dayDiff < 7) {
//         throw new Error('');
//       }
//
//       tempDate.setUTCDate(tempDate.getUTCDay() - dayDiff);
//     }
//
//     if (dateInput.includes('week')) {
//       const dayDiff: number = Number(dateInput.replace(/[^0-9]/g, '')) * 7;
//       tempDate.setUTCDate(tempDate.getUTCDay() - dayDiff);
//     }
//
//     if (dateInput.includes('month')) {
//       // console.log('in month');
//       const monthDiff: number = Number(dateInput.replace(/[^0-9]/g, ''));
//       // console.log('monthDiff: ', monthDiff);
//       tempDate.setUTCMonth(tempDate.getUTCMonth() - monthDiff);
//     }
//
//     if (dateInput.includes('year')) {
//       const yearDiff: number = Number(dateInput.replace(/[^0-9]/g, ''));
//       tempDate.setUTCFullYear(tempDate.getUTCFullYear() - yearDiff);
//     }
//
//     const year: any = tempDate.getUTCFullYear();
//     // console.log('year: ', year);
//     const month: any = tempDate.getUTCMonth();
//     // console.log('month: ', month);
//     const day: any = tempDate.getUTCDate();
//     // console.log('day: ', day);
//
//     if (isNaN(year) || isNaN(month) || isNaN(day) || year < 2000) {
//       throw new Error('');
//     }
//
//     // console.log('Output: ', `${monthNames[month]} ${day}, ${year}`);
//     return `${monthNames[month]} ${day}, ${year}`;
//   } catch (e) {
//     // console.log('Output Catch: ', e);
//     return dateInput;
//   }
// }

export function formatDateByLang(dateMoment: moment.Moment | any) {
  const lang = getCurrentLanguage();
  if (lang === 'ko') {
    return dateMoment.format('YYYY년 M월 D일');
  }
  return dateMoment.format('LL');
}
